import React from "react";
import { useTranslation } from "react-i18next";

const PlayerSelector = ({
  isDarkMode,
  players,
  playerId,
  applyToPlayers,
  setApplyToPlayers,
  selectedDate,
}) => {
  const { t } = useTranslation();
  return (
    <div className="mb-4 text-left">
      <label className="block text-sm font-semibold mb-2">{t("calendar_ui.apply_override")}</label>

      <div
        className={`rounded-md border p-2 max-h-32 overflow-auto ${
          isDarkMode ? "border-gray-700 bg-gray-900" : "border-gray-300 bg-white"
        }`}
      >
        {players
          .filter((p) => String(p.id) !== String(playerId))
          .map((p) => {
            const name =
              p.name ||
              p.full_name ||
              `${p.first_name ?? ""} ${p.last_name ?? ""}`.trim() ||
              p.id;

            const checked = applyToPlayers.includes(String(p.id));

            return (
              <label
                key={p.id}
                className="flex items-center gap-2 py-1 text-sm cursor-pointer"
              >
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={(e) => {
                    const id = String(p.id);
                    setApplyToPlayers((prev) =>
                      e.target.checked ? [...prev, id] : prev.filter((x) => x !== id)
                    );
                  }}
                />
                <span className="truncate">{name}</span>
              </label>
            );
          })}
      </div>

      <p className="text-xs opacity-70 mt-2">
        {t("calendar_ui.apply_override_hint", { date: selectedDate })}
      </p>
    </div>
  );
};

export default PlayerSelector;
